const appstoreurl = 'https://appstore/ciircle'
const playstoreurl = 'https://playstore/ciircle'
const gSheetURL =
	'https://sheet.best/api/sheets/79a91078-bd99-4dc0-8712-cf08105c4eb2'
const main_color = '#8EF9C3'

export { appstoreurl, playstoreurl, gSheetURL, main_color }
